import { render, staticRenderFns } from "./MakeOrder.vue?vue&type=template&id=e507ee94&scoped=true"
import script from "./MakeOrder.vue?vue&type=script&lang=js"
export * from "./MakeOrder.vue?vue&type=script&lang=js"
import style0 from "./MakeOrder.vue?vue&type=style&index=0&id=e507ee94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e507ee94",
  null
  
)

export default component.exports